<template>
  <div id="calendar-filter">
    <div class="pc-calendar-left bg-color-skin">
      <div class="pc-box-now">
        <template v-if="calendarDayDisp">
          <div class="pc-box-date">{{ selectedDate }}</div>
        </template>
        <template v-else>
          <div class="pc-box-date">&nbsp;</div>
        </template>
        <div class="pc-box-month">{{ month[nowLang][selectedMonth-1].full }}</div>
      </div>
      <div class="pc-box-filter bg-color-skin">
        <div class="pc-box-btn" title="Filter">
          <img id="img-list" src="~static/images/filter-btn.png">
        </div>
        <div class="pc-toggle">
          <div class="label-text">Leave</div>
          <div class="toggle">
              <div class="section-slider">
		          <div class="block-slider">
		            <input type="checkbox"  class="silder-checkbox" id="tab1Filter" v-model="inputFilter.tab1" @click="setBtnFilter(inputFilter)">
		            <label class="slider-label" for="tab1Filter">
		              <span class="slider-filter-inner"></span>
		              <span class="slider"></span>
		            </label>
		          </div>
		       </div>
          </div>
        </div>
        <div class="pc-toggle">
          <div class="label-text">Appointment</div>
          <div class="toggle">
              <div class="section-slider">
		          <div class="block-slider">
		            <input type="checkbox"  class="silder-checkbox" id="tab2Filter" v-model="inputFilter.tab2" @click="setBtnFilter(inputFilter)">
		            <label class="slider-label" for="tab2Filter">
		              <span class="slider-filter-inner"></span>
		              <span class="slider"></span>
		            </label>
		          </div>
		       </div>
          </div>
        </div>
        <div class="pc-toggle">
          <div class="label-text">Training</div>
          <div class="toggle">
              <div class="section-slider">
		          <div class="block-slider">
		            <input type="checkbox"  class="silder-checkbox" id="tab3Filter" v-model="inputFilter.tab3" @click="setBtnFilter(inputFilter)">
		            <label class="slider-label" for="tab3Filter">
		              <span class="slider-filter-inner"></span>
		              <span class="slider"></span>
		            </label>
		          </div>
		       </div>
           </div>
        </div>
        <div class="pc-toggle">
          <div class="label-text">To do list</div>
          <div class="toggle">
              <div class="section-slider">
		          <div class="block-slider">
		            <input type="checkbox"  class="silder-checkbox" id="tab4Filter" v-model="inputFilter.tab4" @click="setBtnFilter(inputFilter)">
		            <label class="slider-label" for="tab4Filter">
		              <span class="slider-filter-inner"></span>
		              <span class="slider"></span>
		            </label>
		          </div>
		       </div>
          </div>
        </div>
        <div class="pc-toggle" title="Calendar display mode">
          <div class="toggle2">
              <div class="section-slider">
		          <div class="block-slider">
		            <input type="checkbox"  class="silder-checkbox" id="myslider" v-model="inputSwitch" @change="toggleCalendarSwitch(inputSwitch)">
		            <label class="slider-label" for="myslider">
		              <span class="slider-inner"></span>
		              <span class="slider"></span>
		            </label>
		          </div>
		       </div>
          </div>
        </div>
        
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'calendar_filter_pc',
  data () {
    return {
      inputSwitch: this.checkSwitch,
      inputFilter: this.btnFilter
    }
  },
  watch: {
    checkSwitch () {
      this.inputSwitch = this.checkSwitch
    },
    btnFilter () {
      this.inputFilter = this.btnFilter
    }
  },
  props: [ 'toggleCalendarSwitch', 'toggleCalendar', 'checkSwitch', 'selectedDate', 'month', 'selectedMonth', 'btnFilter', 'setBtnFilter', 'calendarDayDisp', 'nowLang' ]
}
</script>


// WEBPACK FOOTER //
// calendar_filter_pc.vue?39fc18ef